import styled, { css } from 'styled-components';

export const LabelWrapper = styled.div`
  flex: 1;
  margin: 0 8px;
  font-size: 0.9rem;
`;

export const Container = styled.button`
  background-color: transparent;
  border: 0;
  outline: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  transition: background-color 0.3s ease;
  border-radius: 3px;
  font-family: NLRTM;
  font-weight: 500;
  line-height: 1.75;

  &:hover {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.08);
  }

  ${({ disabled }) =>
    disabled &&
    css`
      &:hover {
        cursor: auto;
        background: none;
      }
    `}
`;
